import { type AIInsights } from '@features/ai-insights';
import { Box, Card, Stack, Typography } from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { ReactNode } from 'react';
import { Header } from './Header';
import { LoadingSkeleton } from './LoadingSkeleton';

const parseFormatting = (text: string) =>
  text.split(/(\*\*[^*]+?\*\*)/g).map((chunk, i) => {
    const match = /^\*\*(.*)\*\*$/.exec(chunk);
    return match ? <strong key={`b-${i}`}>{match[1]}</strong> : <>{chunk}</>;
  });

type AIInsightsCardProps = {
  title?: string;
  aiInsights?: AIInsights | null;
  loading?: boolean;
  highlights: ReactNode;
  testId?: string;
};

export const AIInsightsCard = ({
  title,
  aiInsights,
  loading = false,
  highlights,
  testId,
}: AIInsightsCardProps) => {
  if (!aiInsights || aiInsights.summary.length === 0) return highlights;

  return (
    <Card
      data-testid={testId}
      sx={{
        backgroundColor: unifiedPlatformColorPalette.lightGrey50,
        padding: '1rem',
      }}
    >
      <Stack direction="column" gap="1rem">
        <Header title={title} />

        {loading ? (
          <LoadingSkeleton />
        ) : (
          <Box component="ul" pl={2} m={0}>
            {aiInsights.summary.map((summary, index) => (
              <Typography
                key={[summary, index].join('-')}
                component="li"
                color={unifiedPlatformColorPalette.lightTextPrimary}
              >
                {parseFormatting(summary)}
              </Typography>
            ))}
          </Box>
        )}
      </Stack>
    </Card>
  );
};
